export default class Hamburger {
  constructor() {
    this.menuIcon = document.querySelector('.menu__mobile__icon__hamburger')

    this.menuList = document.querySelector('.menu__mobile__links')

    this.menuFlag = true

    this.click()
  }

  click() {
    this.menuIcon.addEventListener('click', () => {
      if (this.menuFlag) {
        this.open()
        this.menuFlag = false
      } else {
        this.close()
        this.menuFlag = true
      }
    })
  }

  open() {
    document.body.style.overflowY = 'hidden'
    this.menuList.classList.add('menu__mobile__links__opened')
  }

  close() {
    document.body.style.overflowY = 'scroll'
    this.menuList.classList.remove('menu__mobile__links__opened')
  }
}
